import { Consultant } from './../Consultant.model';
import { ResponsibleFinancial } from './ResponsibleFinancial.model';
import { CompanyFinancial } from './CompanyFinancial.model';
import { CompanyGroupsFinancial } from './CompanyGroupsFinancial.model';
import { Project } from '../Project.model';
import {SubDivision} from '../SubDivision.model';
import { ExcellenceCenter } from "../ExcellenceCenter.model";
export class ProjectFinancial {
    _id: string;
    name: string;
    company: CompanyFinancial = new CompanyFinancial();
    companyGroup: CompanyGroupsFinancial = new CompanyGroupsFinancial();
    hashTrack: Array<Project> = new Array<Project>();
    userResponsable: ResponsibleFinancial = new ResponsibleFinancial();
    consultants: Array<Consultant> = new Array<Consultant>();
    proposalDeleted: boolean;
    active: boolean = true;
    dateCreate: Date = null;
    subDivision: SubDivision = new SubDivision();
    sapProjectId: string;
    projectExpense: boolean;
    companyId?: string;
    teamGroups: any = [];
    excellenceCenters: Array<ExcellenceCenter> = [];

    loadFromServer(r: any) {

        if (r._id)
            this._id = r._id;

        if (r.name)
            this.name = r.name;

        if (r.hashTrack) {
            r.hashTrack.forEach(element => {
                var projectHash = new Project();
                element.owner = undefined;
                projectHash.loadFromServer(element);
                this.hashTrack.push(projectHash);
            });
        }

        if (r.proposalDeleted !== undefined)
            this.proposalDeleted = r.proposalDeleted;

        if (r.company !== undefined)
            this.company.loadFromServer(r.company);

        if (r.companyGroup !== undefined)
            this.companyGroup.loadFromServer(r.companyGroup);

        if (r.userResponsable !== undefined)
            this.userResponsable.loadFromServer(r.userResponsable);

        if (r.consultants !== undefined) {
            r.consultants.forEach(element => {
                var consultant = new Consultant();
                consultant.loadConsultantFromServer(element);
                this.consultants.push(consultant);
            });
        } else {
            this.consultants = new Array<Consultant>();
        }

        if(r.active !== undefined)
            this.active = r.active;

        if (r.subDivision !== undefined)
            this.subDivision = r.subDivision;

        if (r.sapProjectId !== undefined)
            this.sapProjectId = r.sapProjectId;

        if (r.companyId)
            this.companyId = r.companyId;

        if (r.teamGroups)
            this.teamGroups = r.teamGroups;

        if (r.projectExpense)
            this.projectExpense = r.projectExpense;

        if (r.excellenceCenters !== undefined)
            this.excellenceCenters = [...r.excellenceCenters];
    }
}



// WEBPACK FOOTER //
// ./src/app/models/project/ProjectFinancial.model.ts